module.exports = __webpack_public_path__ + "static/media/gif.53b3cd08.svg";